import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";


export interface LocalizationState {
  selectedLanguage: string,
}

const initialState: LocalizationState = {
  selectedLanguage: 'en'
};

export const localizationSlice = createSlice({
  name: 'localization',
  initialState,
  reducers: {
    setSelectedLanguage: (state, action: PayloadAction<string>) => {
      state.selectedLanguage = action.payload;
    },
  },
  extraReducers: (builder: any) => {},
});

export const { setSelectedLanguage } = localizationSlice.actions;

export const selectLanguage = (state: RootState): string => state.localization.selectedLanguage;

export default localizationSlice.reducer;